import './index.scss';



/** WEBPACK FOOTER **
 ** ./src/NewsList/index.js
 **/